// extracted by mini-css-extract-plugin
module.exports = {"container":"appBadges_container__ZK55e"};